import appConfig from '../app-config';
export const guestInfoClients = ['onekingwest_amenities'];
export const isGuestOrderInfoClient = guestInfoClients.includes(
  appConfig.appSource
);
